import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=ed22e7ea&"
import script from "./BaseFilter.vue?vue&type=script&lang=js&"
export * from "./BaseFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports